import {IMessageData} from "../../../index";
import * as ko from "knockout";
import PromiseRequest from "../../../req/PromiseRequest";
import {global} from "../../../appContext";
import {createErrorMessage} from "../../../util/misc";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {DELETING_MESSAGE} from "../../../constants/Language";
import {nsAmplify} from "../../../util/nsAmplify";
import {ButtonManager} from "../../../util/ButtonManager";
import {getCancelButton, getContinueButton} from "../../../constants/RouteDefinitions";
import {IDialogOptionsComponent} from "../../dialog/index";
import {nsRoute} from "../../../util/route";
import ButtonOrder = nsRoute.ButtonOrder;
import delete_customerHtml from './delete.customer.html?raw';

export let template: string = delete_customerHtml;

enum Step {
    Init,
    Confirm,
    Process,
    Success,
    Error
}

export class viewModel {
    customerName: string;
    Step = Step;
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    step: KnockoutObservable<number> = ko.observable(Step.Init);
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private req_deletecompany: PromiseRequest = new PromiseRequest("deletecompany");
    private readonly pageButtons: ButtonManager = new ButtonManager()

    constructor(protected params: { dialog: IDialogOptionsComponent }) {
        this.kosub.subscribe(this.step, this.updateStep.bind(this));
        this.customerName = global.login.selectedOrganization()?.organizationame ?? '';

        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.(), {
            label: 'no, cancel',
            validator: () => this.isStep(Step.Init, Step.Confirm),
        }))
        this.pageButtons.add(getContinueButton({
            cssClass: 'danger',
            label: 'Ja, fortsett',
            onClick: () => this.onNextStepClick(),
            validator: () => this.isStep(Step.Init),
        }))
        this.pageButtons.add(getContinueButton({
            cssClass: 'danger',
            label: 'Ja, jeg er 100% sikker',
            onClick: () => this.onNextStepClick(),
            validator: () => this.isStep(Step.Confirm),
        }))
        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.(), {
            label: 'Nei, lukk',
            validator: () => this.isStep(Step.Success),
        }))
        this.pageButtons.add(getContinueButton({
            label: 'Ja, restart applikasjon',
            onClick: () => this.onResetApplicationClick(),
            validator: () => this.isStep(Step.Success),
        }))
        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.(), {
            cssClass: 'primary action',
            icon: 'fa-check',
            label: 'close',
            order: ButtonOrder.CONTINUE,
            validator: () => this.isStep(Step.Error),
        }))
    }

    protected updateStep() {
        switch (this.step()) {
            case Step.Init:
                break;
            case Step.Confirm:
                break;
            case Step.Process:
                this.messageData(null);
                this.params.dialog.isClosable?.(false);

                Promise.resolve()
                    .then(() => {
                        this.messageData({message: DELETING_MESSAGE});
                        const timeoutDuration = 5 // hrs
                            * 60 // min
                            * 60 // sek
                            * 1000 // ms
                        ;
                        return this.req_deletecompany
                            .request({id: global.login.selectedOrganizationId()}, false, {timeout: timeoutDuration})
                            .then(() => {
                                global.cacheManager.removeCache("getcompany");
                                global.cacheManager.removeCache("getcompanylogin");
                            });
                    })
                    .then(() => {
                        nsAmplify.store("storedOrganizationId", null);
                        this.messageData(null);
                        this.step(Step.Success);
                    })
                    .catch((reason: string) => {
                        this.messageData(createErrorMessage(String(reason)));
                        this.step(Step.Error);
                    });
                break;
            case Step.Success:
            case Step.Error:
                this.params.dialog.isClosable?.(true);
                break;
        }
    }

    onNextStepClick() {
        this.step(this.step() + 1);
    }

    isStep(...steps: number[]): boolean {
        return steps.reduce((bool: boolean, step: number) => bool || step === this.step(), false);
    }

    onResetApplicationClick() {
        window.location.reload();
    }

    dispose() {
        this.kosub.unsuscribeAll();
        this.req_deletecompany.abort();
    }

}
